import {Injectable} from '@angular/core';
import {AbstractControl, ValidatorFn} from "@angular/forms";
import libphonenumber from 'google-libphonenumber';

/*
 Generated class for the PhoneValidatorProvider provider.

 See https://angular.io/guide/dependency-injection for more info on providers
 and Angular DI.
 */
@Injectable({
  providedIn:'root'
})
export class PhoneValidatorProvider {
  
  // Inspired on: https://github.com/yuyang041060120/ng2-validation/blob/master/src/equal-to/validator.ts
  static validCountryPhone = (countryControl: AbstractControl): ValidatorFn => {
    let subscribe: boolean = false;
    
    return (phoneControl: AbstractControl): { [key: string]: boolean } => {
      if (!subscribe) {
        subscribe = true;
        countryControl.valueChanges.subscribe(() => {
          phoneControl.updateValueAndValidity();
        });
      }
      
      if (phoneControl.value !== "") {
        try {
         
   
          const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
          let phoneNumber = "" + phoneControl.value + "",
            region = countryControl.value.iso,
            number = phoneUtil.parse(phoneNumber, region),
            isValidNumber = phoneUtil.isValidNumber(number);
          
          let countryCode = countryControl.value.code.replace('+','');
          if(phoneControl.value.indexOf(countryControl.value.code)===0||
          phoneControl.value.indexOf(countryCode)===0||
          phoneControl.value.indexOf( '+')===0){
            return {
              validCountryPhone: true
            };
          }
          if (isValidNumber) {
            return null;
          }
        } catch (e) {
          // console.log(e);
          return {
            validCountryPhone: true
          };
        }
        
        return {
          validCountryPhone: true
        };
      }
      else {
        return null;
      }
    };
  };
  
  constructor() {
  }
  
}
